/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, LinearProgress, MenuItem, Pagination, Select, Stack, Tab, Tabs, TextField,
} from '@mui/material';
import { DriveFileRenameOutlineOutlined, ExpandMoreRounded, Search } from '@mui/icons-material';
import moment from 'moment';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import {
  getCustomerDetails,
  getCustomerItems,
  getCustomerMarket,
  getCustomerRequests,
  getCustomerSubs,
  getCustomerWallet,
} from '../../../../Redux/Models/customer';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';

const tabsData = [
  {
    label: 'Request History',
    value: 'request',
  },
  {
    label: 'Subscription History',
    value: 'subscription',
  },
  {
    label: 'Market History',
    value: 'market',
  },
  {
    label: 'OenoWallet History',
    value: 'wallet',
  },
];

export default function Component({
  user, classes, error, message, isLoading,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId } = useParams();

  const { openAlert } = useContext(AlertContext);

  const [activeTab, setActiveTab] = useState('request');

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    dispatch(getCustomerDetails(userId));
  }, [userId]);

  const renderActivePil = () => (
    <Box
      fontSize={12}
      fontWeight="700"
      mt={0.5}
      bgcolor="#DBF9DB"
      color="#38AC3D"
      borderRadius="4px"
      py="2px"
      px={1}
      display="inline-flex"
    >
      Active
    </Box>
  );

  return (
    <Elements.AdminPageBase navigate={navigate}>
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>Customer</strong>
          </Box>
          {/* <Box
            display="flex"
            alignItems="center"
            gap={1}
            py={1}
            px={2}
            bgcolor="#FDFDFD"
            borderRadius="10px"
            border="1px solid #E5E5E5"
            className="link"
            fontSize={14}
          >
            <img src={Images.Download} alt="download" height="20" width="20" />
            Download Order Report
          </Box> */}
        </Box>

        {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}

        <Box p={3} bgcolor="#FDFDFD" borderRadius="10px" mt={4}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box fontSize={18} fontWeight="700">Profile Information</Box>
            {/* <Box display="flex" gap={1}
            alignItems="center" fontSize={12}
            className="primary-green link"
            onClick={() => navigate(`${ROUTES.customers()}/update/${userId}`)}>
              <DriveFileRenameOutlineOutlined fontSize="small" />
              Edit Information
            </Box> */}
          </Box>

          <Box fontWeight="700" fontSize={12} mt={3}>Profile</Box>

          <Box display="flex" mt={2} alignItems="flex-start" flexWrap="wrap" gap={2}>
            <Box flex={1}>
              <Stack direction="column" spacing={1}>
                <Box>
                  <Box className="mute" fontSize={12}>Customer ID</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{user.customer_info?.id}</Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Name</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{user.personal_data?.name}</Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Since</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{moment(user.customer_info?.join_date).format('DD MMM YYYY, HH.mm')}</Box>
                </Box>
              </Stack>
            </Box>
            <Box flex={1}>
              <Stack direction="column" spacing={1}>
                <Box>
                  <Box className="mute" fontSize={12}>Phone Number</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{user.personal_data?.phone_number || '-'}</Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Email</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>{user.personal_data?.email}</Box>
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Items in Storage</Box>
                  <Box fontSize={14} fontWeight="700" mt={0.5}>8 Items & 2 Boxes</Box>
                </Box>
              </Stack>
            </Box>
            <Box flex={1}>
              <Stack direction="column" spacing={1}>
                <Box>
                  <Box className="mute" fontSize={12}>OenoWallet</Box>
                  {renderActivePil()}
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>OenoMarket Sellers</Box>
                  {renderActivePil()}
                </Box>
                <Box>
                  <Box className="mute" fontSize={12}>Customer Type</Box>
                  <Box display="inline-flex" className="gap-4 class align-items-center" fontWeight="700" mt={0.5} fontSize={14}>
                    <img height="20" src={user.customer_info?.membership === 'Business to Customer (B2C)' ? Images.IconSubscription : Images.PremiumStar} alt="star" />
                    <Box>{user.customer_info?.membership}</Box>
                  </Box>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Box>

        <Box px={3} pb={3} pt={2} bgcolor="#FDFDFD" borderRadius="10px" mt={4}>
          <Tabs value={activeTab} className={`${classes.tabs}`} onChange={(e, newType) => setActiveTab(newType)}>
            {tabsData.map((tab) => (
              <Tab
                label={(
                  <Box display="flex" gap={1.5} alignItems="center">
                    {tab.label}
                  </Box>
                )}
                value={tab.value}
                key={tab.value}
                disableRipple
              />
            ))}
          </Tabs>
          <Box mt={3}>
            <Box display={activeTab === 'request' ? 'block' : 'none'}>
              <CustomerRequests userId={userId} />
            </Box>
            <Box display={activeTab === 'subscription' ? 'block' : 'none'}>
              <CustomerSubs userId={userId} />
            </Box>
            <Box display={activeTab === 'market' ? 'block' : 'none'}>
              <CustomerMarket userId={userId} />
            </Box>
            <Box display={activeTab === 'wallet' ? 'block' : 'none'}>
              <CustomerWallet userId={userId} />
            </Box>
          </Box>
        </Box>

        <ItemsInStorage userId={userId} />
      </div>
    </Elements.AdminPageBase>
  );
}

function ItemsInStorage({ userId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');

  const {
    customerItems,
    customerItemsMeta,
    isLoadingItems: isLoading,
  } = useSelector((state) => state.customer);
  const { totalPage, currentPage, total } = customerItemsMeta;

  const getData = () => {
    dispatch(getCustomerItems(userId, { keyword, limit, page }));
  };

  useEffect(() => {
    getData();
  }, [keyword, limit, page]);

  return (
    <Box px={3} pb={3} pt={2} bgcolor="#FDFDFD" borderRadius="10px" mt={4}>
      <Box fontSize={18} fontWeight="700">Items in Storage</Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
        <Box className="mute s-12">
          <strong>{total || 0}</strong>
          {' '}
          data
        </Box>
        <Box display="flex" gap={2} alignItems="center">
          <Select
            select
            size="small"
            value={limit}
            onChange={({ target }) => setLimit(target.value)}
            IconComponent={ExpandMoreRounded}
            sx={{
              borderRadius: '10px',
              bgcolor: '#fff',
            }}
          >
            <MenuItem value={10}>10 List</MenuItem>
            <MenuItem value={20}>20 List</MenuItem>
            <MenuItem value={50}>50 List</MenuItem>
          </Select>
          <TextField
            placeholder="Search by keyword"
            size="small"
            sx={{
              ' .MuiInputBase-root': {
                bgcolor: '#fff',
              },
            }}
            InputProps={{
              startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
            }}
            value={keyword}
            onChange={({ target }) => setKeyword(target.value)}
          />
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            size="small"
            page={!isLoading ? currentPage : page}
            siblingCount={0}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </Box>
      </Box>
      {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}
      {customerItems && customerItems?.length
        ? (
          <table style={{ marginTop: 16 }}>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Item ID</td>
                <td className="white">Request ID</td>
                <td className="white">Date In</td>
                <td className="white">Item Type</td>
                <td className="white">Quantity</td>
                <td className="white">Market Status</td>
                <td className="white">Storage Location</td>
              </tr>
            </thead>
            <tbody>
              {customerItems?.map((item) => (
                <tr key={item.wine_id}>
                  <td>
                    <Link to={ROUTES.storage()} className="primary-green">
                      {item.wine_id?.slice(0, 5)}
                      ...
                    </Link>
                  </td>
                  <td>
                    <Link to={ROUTES.request()} className="primary-green">
                      {item.request_id?.slice(0, 5)}
                      ...
                    </Link>
                  </td>
                  <td>{moment(item.date_in).format('DD MMM YYYY, HH.mm')}</td>
                  <td>{item.item_type}</td>
                  <td>{item.item_quantity}</td>
                  <td>{item.market_status}</td>
                  <td>{item.storage_location}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="s-16 mt-5 center">
            <img src={Images.Sure} alt="No data" />
            <div className="weight-700 mt-4">No item yet</div>
            <div className="mt-2">User item will appear here</div>
          </div>
        )}
    </Box>
  );
}

function CustomerRequests({ userId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');

  const {
    customerRequests,
    customerRequestsMeta,
    isLoadingRequests: isLoading,
  } = useSelector((state) => state.customer);
  const { totalPage, currentPage, total } = customerRequestsMeta;

  const getData = () => {
    dispatch(getCustomerRequests(userId, { keyword, limit, page }));
  };

  useEffect(() => {
    getData();
  }, [keyword, limit, page]);

  return (
    <Box mt={3}>
      <Box fontSize={18} fontWeight="700">Request History</Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
        <Box className="mute s-12">
          <strong>{total || 0}</strong>
          {' '}
          data
        </Box>
        <Box display="flex" gap={2} alignItems="center">
          <Select
            select
            size="small"
            value={limit}
            onChange={({ target }) => setLimit(target.value)}
            IconComponent={ExpandMoreRounded}
            sx={{
              borderRadius: '10px',
              bgcolor: '#fff',
            }}
          >
            <MenuItem value={10}>10 List</MenuItem>
            <MenuItem value={20}>20 List</MenuItem>
            <MenuItem value={50}>50 List</MenuItem>
          </Select>
          <TextField
            placeholder="Search by keyword"
            size="small"
            sx={{
              ' .MuiInputBase-root': {
                bgcolor: '#fff',
              },
            }}
            InputProps={{
              startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
            }}
            value={keyword}
            onChange={({ target }) => setKeyword(target.value)}
          />
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            size="small"
            page={!isLoading ? currentPage : page}
            siblingCount={0}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </Box>
      </Box>
      {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}
      {customerRequests && customerRequests?.length
        ? (
          <table style={{ marginTop: 16 }}>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Order ID</td>
                <td className="white">Status</td>
                <td className="white">Service</td>
                <td className="white">Order Date</td>
                <td className="white">Courier</td>
                <td className="white">Destination</td>
              </tr>
            </thead>
            <tbody>
              {customerRequests?.map((req) => (
                <tr key={req.id}>
                  <td>
                    <Link to={`${req.service === 'Request Out' ? ROUTES.requestOut() : ROUTES.requestIn()}/${req.id}`} className="primary-green">
                      {req.id?.slice(0, 5)}
                      ...
                    </Link>
                  </td>
                  <td>{req.status}</td>
                  <td>{req.service}</td>
                  <td>{req.date_order ? moment(req.date_order).format('DD MMM YYYY, HH.mm') : '-'}</td>
                  <td>{req.courier_name || '-'}</td>
                  <td>{req.destination || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="s-16 mt-5 center">
            <img src={Images.Sure} alt="No data" />
            <div className="weight-700 mt-4">No request yet</div>
            <div className="mt-2">User request will appear here</div>
          </div>
        )}
    </Box>
  );
}

function CustomerSubs({ userId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');

  const {
    customerSubs,
    customerSubsMeta,
    isLoadingSubs: isLoading,
  } = useSelector((state) => state.customer);
  const { totalPage, currentPage, total } = customerSubsMeta;

  const getData = () => {
    dispatch(getCustomerSubs(userId, { keyword, limit, page }));
  };

  useEffect(() => {
    getData();
  }, [keyword, limit, page]);

  return (
    <Box mt={3}>
      <Box fontSize={18} fontWeight="700">Subscription History</Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
        <Box className="mute s-12">
          <strong>{total || 0}</strong>
          {' '}
          data
        </Box>
        <Box display="flex" gap={2} alignItems="center">
          <Select
            select
            size="small"
            value={limit}
            onChange={({ target }) => setLimit(target.value)}
            IconComponent={ExpandMoreRounded}
            sx={{
              borderRadius: '10px',
              bgcolor: '#fff',
            }}
          >
            <MenuItem value={10}>10 List</MenuItem>
            <MenuItem value={20}>20 List</MenuItem>
            <MenuItem value={50}>50 List</MenuItem>
          </Select>
          <TextField
            placeholder="Search by keyword"
            size="small"
            sx={{
              ' .MuiInputBase-root': {
                bgcolor: '#fff',
              },
            }}
            InputProps={{
              startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
            }}
            value={keyword}
            onChange={({ target }) => setKeyword(target.value)}
          />
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            size="small"
            page={!isLoading ? currentPage : page}
            siblingCount={0}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </Box>
      </Box>
      {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}
      {customerSubs && customerSubs?.length
        ? (
          <table style={{ marginTop: 16 }}>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Transaction ID</td>
                <td className="white">Status</td>
                <td className="white">Order Type</td>
                <td className="white">Customer Type</td>
                <td className="white">Order Date</td>
                <td className="white">Payment Method</td>
              </tr>
            </thead>
            <tbody>
              {customerSubs?.map((req) => (
                <tr key={req.id}>
                  <td>
                    <Link to="/" className="primary-green">
                      {req.id?.slice(0, 5)}
                      ...
                    </Link>
                  </td>
                  <td>{req.status}</td>
                  <td>{req.order_type}</td>
                  <td>{req.customer_type || '-'}</td>
                  <td>{req.order_date ? moment(req.order_date).format('DD MMM YYYY, HH.mm') : '-'}</td>
                  <td>{req.payment_method || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="s-16 mt-5 center">
            <img src={Images.Sure} alt="No data" />
            <div className="weight-700 mt-4">No subscription history yet</div>
            <div className="mt-2">User subscription history will appear here</div>
          </div>
        )}
    </Box>
  );
}

function CustomerWallet({ userId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');

  const {
    customerWallet,
    customerWalletMeta,
    isLoadingWallet: isLoading,
  } = useSelector((state) => state.customer);
  const { totalPage, currentPage, total } = customerWalletMeta;

  const getData = () => {
    dispatch(getCustomerWallet(userId, { keyword, limit, page }));
  };

  useEffect(() => {
    getData();
  }, [keyword, limit, page]);

  return (
    <Box mt={3}>
      <Box fontSize={18} fontWeight="700">Market History</Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
        <Box className="mute s-12">
          <strong>{total || 0}</strong>
          {' '}
          data
        </Box>
        <Box display="flex" gap={2} alignItems="center">
          <Select
            select
            size="small"
            value={limit}
            onChange={({ target }) => setLimit(target.value)}
            IconComponent={ExpandMoreRounded}
            sx={{
              borderRadius: '10px',
              bgcolor: '#fff',
            }}
          >
            <MenuItem value={10}>10 List</MenuItem>
            <MenuItem value={20}>20 List</MenuItem>
            <MenuItem value={50}>50 List</MenuItem>
          </Select>
          <TextField
            placeholder="Search by keyword"
            size="small"
            sx={{
              ' .MuiInputBase-root': {
                bgcolor: '#fff',
              },
            }}
            InputProps={{
              startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
            }}
            value={keyword}
            onChange={({ target }) => setKeyword(target.value)}
          />
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            size="small"
            page={!isLoading ? currentPage : page}
            siblingCount={0}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </Box>
      </Box>
      {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}
      {customerWallet && customerWallet?.length
        ? (
          <table style={{ marginTop: 16 }}>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Transaction ID</td>
                <td className="white">Status</td>
                <td className="white">Date</td>
                <td className="white">Service Type</td>
                <td className="white">Amount</td>
                <td className="white">Transfered To</td>
                <td className="white">Payment Method</td>
              </tr>
            </thead>
            <tbody>
              {customerWallet?.map((req) => (
                <tr key={req.id}>
                  <td>
                    <Link to="/" className="primary-green">
                      {req.id?.slice(0, 5)}
                      ...
                    </Link>
                  </td>
                  <td>{req.status}</td>
                  <td>{req.order_type}</td>
                  <td>{req.customer_type || '-'}</td>
                  <td>{req.order_date ? moment(req.order_date).format('DD MMM YYYY, HH.mm') : '-'}</td>
                  <td>{req.payment_method || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="s-16 mt-5 center">
            <img src={Images.Sure} alt="No data" />
            <div className="weight-700 mt-4">No OenoWallet transaction history yet</div>
            <div className="mt-2">User OenoWallet transaction history will appear here</div>
          </div>
        )}
    </Box>
  );
}

function CustomerMarket({ userId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');

  const {
    customerMarket,
    customerMarketMeta,
    isLoadingMarket: isLoading,
  } = useSelector((state) => state.customer);
  const { totalPage, currentPage, total } = customerMarketMeta;

  const getData = () => {
    dispatch(getCustomerMarket(userId, { keyword, limit, page }));
  };

  useEffect(() => {
    getData();
  }, [keyword, limit, page]);

  return (
    <Box mt={3}>
      <Box fontSize={18} fontWeight="700">Market History</Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
        <Box className="mute s-12">
          <strong>{total || 0}</strong>
          {' '}
          data
        </Box>
        <Box display="flex" gap={2} alignItems="center">
          <Select
            select
            size="small"
            value={limit}
            onChange={({ target }) => setLimit(target.value)}
            IconComponent={ExpandMoreRounded}
            sx={{
              borderRadius: '10px',
              bgcolor: '#fff',
            }}
          >
            <MenuItem value={10}>10 List</MenuItem>
            <MenuItem value={20}>20 List</MenuItem>
            <MenuItem value={50}>50 List</MenuItem>
          </Select>
          <TextField
            placeholder="Search by keyword"
            size="small"
            sx={{
              ' .MuiInputBase-root': {
                bgcolor: '#fff',
              },
            }}
            InputProps={{
              startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
            }}
            value={keyword}
            onChange={({ target }) => setKeyword(target.value)}
          />
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            size="small"
            page={!isLoading ? currentPage : page}
            siblingCount={0}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </Box>
      </Box>
      {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}
      {customerMarket && customerMarket?.length
        ? (
          <table style={{ marginTop: 16 }}>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Transaction ID</td>
                <td className="white">Status</td>
                <td className="white">Date</td>
                <td className="white">Service Type</td>
                <td className="white">Amount</td>
                <td className="white">Transfered To</td>
                <td className="white">Payment Method</td>
              </tr>
            </thead>
            <tbody>
              {customerMarket?.map((req) => (
                <tr key={req.id}>
                  <td>
                    <Link to="/" className="primary-green">
                      {req.id?.slice(0, 5)}
                      ...
                    </Link>
                  </td>
                  <td>{req.status}</td>
                  <td>{req.order_type}</td>
                  <td>{req.customer_type || '-'}</td>
                  <td>{req.order_date ? moment(req.order_date).format('DD MMM YYYY, HH.mm') : '-'}</td>
                  <td>{req.payment_method || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="s-16 mt-5 center">
            <img src={Images.Sure} alt="No data" />
            <div className="weight-700 mt-4">No market history yet</div>
            <div className="mt-2">User market history will appear here</div>
          </div>
        )}
    </Box>
  );
}
